import {EntityModel} from "@fedeltapointofsale/data-client";
import {InventoryData} from "./inventory.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class InventoryEntityModel extends EntityModel<InventoryData> {
    constructor(injector: Injector) {
        super(injector, InventoryData);
    }

    protected override onAfterLoadEntity(entityData: InventoryData): void {
        const preferredSupplier: number = this.data.preferredSupplier.vendorId;
        const inventoryArr: Array<any> = this.data.suppliedInventories;
        for (let i = 0; i < inventoryArr.length; i++) {
            if (preferredSupplier == inventoryArr[i].vendor.vendorId) {
                inventoryArr[i].preferredSupplier = true;
            }
        }
    }

}
